import { Box, COLOR_PALETTE, Text } from '@inflearn/ds-react';
import type { ReactNode } from 'react';

export function StatItem({ label, content }: { label: string; content: string | ReactNode }) {
  return (
    <Box
      css={{
        padding: '12px 16px',
        border: `1px solid ${COLOR_PALETTE.gray[2]}`,
        borderRadius: 8,
      }}
    >
      <Text size={12} fw={500} lh="1.5" color="gray.6">
        {label}
      </Text>
      {typeof content === 'string' ? (
        <Text size={16} fw={600} lh="1.7" color="gray.9">
          {content}
        </Text>
      ) : (
        content
      )}
    </Box>
  );
}
